/**
 *
 * @param {File} file
 * @returns {string}
 */
function readAsDataURL (file) {
  const reader = new FileReader()

  return new Promise((resolve, reject) => {
    reader.addEventListener('load', () => {
      resolve(reader.result)
    }, false)

    reader.readAsDataURL(file)
  })
}

export {
  readAsDataURL
}
